<template>
	<div>
		<!-- 查询表单 -->
		<el-form :inline="true">
			<el-form-item label="操作时间">
				<!-- 绑定 disabledDate 和 calendar-change 事件 -->
				<el-date-picker 
					v-model="queryForm.queryTime" 
					type="datetimerange" 
					range-separator="至"
					start-placeholder="开始日期" 
					end-placeholder="结束日期" 
					value-format="YYYY-MM-DD HH:mm:ss"
					:default-time="[new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]"
					:disabled-date="disabledDate"
					@calendar-change="calendarChange">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="扫描类型">
				<el-select v-model="queryForm.scanTypeCode" placeholder="扫描类型" style="width: 240px">
					<el-option v-for="item in scanTypeList" :key="item.code" :label="item.name" :value="item.code" />
				</el-select>
			</el-form-item>
			<el-form-item label="扫描状态">
				<el-select v-model="queryForm.scanStatusCode" placeholder="扫描状态" style="width: 240px">
					<el-option v-for="item in scanStatusList" :key="item.code" :label="item.name" :value="item.code" />
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="get_subscription_list(queryForm)">查询</el-button>
			</el-form-item>
		</el-form>

		<!-- 统计卡片区域 -->
		<el-row :gutter="16" class="stat-cards">
			<el-col :span="3" v-for="item in statusStats" :key="item.code">
				<el-card 
					shadow="hover" 
					class="stat-card" 
					:class="{ 'is-active': activeStatusCode === item.code }"
					@click="handleCardClick(item.code)">
					<div class="stat-label">{{ item.name }}</div>
					<div class="stat-value" :class="`status-color-${item.code || 'default'}`">
						{{ item.count }}
					</div>
				</el-card>
			</el-col>
		</el-row>

		<!-- 数据表格：绑定 v-loading="loading" 实现加载动画 -->
		<el-table :data="filteredScanList" style="width: 100%;padding: 1em;" v-loading="loading">
			<el-table-column prop="waybillNo" label="运单号">
				<template #default="scope">
					<div style="display: flex;align-items: center;">
						<div @click="waybillQueryPopup({cpCode: scope.row.cpCode,waybillNo: scope.row.waybillNo,phone: ''})"
							style="color: #409EFF;cursor: pointer;">
							{{scope.row.waybillNo}}
						</div>
						<el-icon v-if="scope.row.waybillNo" @click="common.copy(scope.row.waybillNo)"
							style="left: 0.7em;">
							<CopyDocument />
						</el-icon>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="scanTypeName" label="操作类型" show-overflow-tooltip></el-table-column>
			<el-table-column prop="latestTrackStatusCode" label="物流状态" 
				:filters="trackStatusMap" 
				:filter-method="filterHandler">
				<template #default="scope">{{scope.row.latestTrackStatusName}}</template>
			</el-table-column>
			<el-table-column prop="latestTrackDescription" label="最新轨迹" show-overflow-tooltip></el-table-column>
			<el-table-column prop="latestTrackTime" label="轨迹更新时间" show-overflow-tooltip></el-table-column>
			<el-table-column prop="uploadTime" label="操作上传时间"></el-table-column>
		</el-table>
	</div>
</template>

<script>
	import dayjs from 'dayjs';
	export default {
		data() {
			return {
				queryForm: {
					queryTime: [],
					scanTypeCode: "picked",
					scanStatusCode: "normal"
				},
				scanList: [],
				scanStatusList: [
					{ name: "正常", code: "normal" }, 
					{ name: "异常", code: "abnormal" }
				],
				scanTypeList: [
					{ name: "取件", code: "picked" }
				],
				trackStatusMap: [
					{ text: '未发出', value: '' },
					{ text: '已取件', value: 'GOT' },
					{ text: '已揽收', value: 'COLLECT' },
					{ text: '运输中', value: 'TRANSPORT' },
					{ text: '派送中', value: 'DELIVERING' },
					{ text: '入库入柜', value: 'REJECT' },
					{ text: '拒收', value: 'FAILED' },
					{ text: '异常签收', value: 'FAILED' }
				],
				activeStatusCode: null,
				loading: false, // 【新增】表格加载状态
				firstChooseDate: null // 【新增】记录日期范围选择器中第一次选中的日期
			}
		},
		computed: {
			statusStats() {
				const counts = {};
				this.trackStatusMap.forEach(item => {
					counts[item.value] = 0;
				});
				this.scanList.forEach(row => {
					const code = row.latestTrackStatusCode;
					if (Object.prototype.hasOwnProperty.call(counts, code)) {
						counts[code]++;
					}
				});
				return this.trackStatusMap.map(item => ({
					code: item.value,
					name: item.text,
					count: counts[item.value]
				}));
			},
			filteredScanList() {
				if (this.activeStatusCode === null) {
					return this.scanList;
				}
				return this.scanList.filter(row => row.latestTrackStatusCode === this.activeStatusCode);
			}
		},
		created() {
			this.initDefaultTime();
			this.get_subscription_list(this.queryForm);
		},
		methods: {
			// 【新增】限制日期范围最多7天
			disabledDate(time) {
				if (this.firstChooseDate) {
					const oneDay = 24 * 3600 * 1000;
					// 7天的时间跨度（包含起始日，所以是 +6天）
					const maxTime = this.firstChooseDate + 6 * oneDay;
					const minTime = this.firstChooseDate - 6 * oneDay;
					return time.getTime() < minTime || time.getTime() > maxTime;
				}
				return false;
			},
			// 【新增】监听日历面板选择过程，获取第一次点击的日期
			calendarChange(val) {
				if (val && val.length > 0 && val[0]) {
					this.firstChooseDate = new Date(val[0]).getTime();
				} else {
					this.firstChooseDate = null;
				}
			},
			handleCardClick(code) {
				if (this.activeStatusCode === code) {
					this.activeStatusCode = null;
				} else {
					this.activeStatusCode = code;
				}
			},
			filterHandler(value, row, column) {
				const property = column['property'];
				return row[property] === value;
			},
			get_subscription_list(queryForm) {
				this.loading = true; // 请求开始，开启加载动画
				this.apiService.post({
						modules: "getScanList",
						content: queryForm
					})
					.then((res) => {
						if (res.status) {
							this.scanList = res.data.scanList;
						}
					})
					.finally(() => {
						this.loading = false; // 请求结束（无论成功失败），关闭加载动画
					});
			},
			initDefaultTime() {
				try {
					const endDate = dayjs().endOf('day');
					const startDate = dayjs().subtract(1, 'day').startOf('day');
					this.queryForm.queryTime = [
						startDate.format('YYYY-MM-DD HH:mm:ss'),
						endDate.format('YYYY-MM-DD HH:mm:ss')
					];
				} catch (e) {
					console.error("时间初始化失败", e);
					const now = new Date();
					const start = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000);
					const fmt = (d) => {
						const pad = (n) => n < 10 ? '0' + n : n;
						return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
					};
					this.queryForm.queryTime = [fmt(start), fmt(now)];
				}
			}
		}
	}
</script>

<style scoped>
	.stat-cards { margin-bottom: 16px; }
	.stat-card { text-align: center; cursor: pointer; transition: all 0.3s ease; }
	.stat-card.is-active { border-color: #409EFF; background-color: #ecf5ff; }
	.stat-label { font-size: 14px; color: #909399; margin-bottom: 8px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
	.stat-value { font-size: 24px; font-weight: bold; color: #303133; line-height: 1.2; }
	.status-color-GOT { color: #409EFF; }       
	.status-color-COLLECT { color: #67C23A; }   
	.status-color-TRANSPORT { color: #E6A23C; } 
	.status-color-DELIVERING { color: #409EFF; }
	.status-color-REJECT { color: #909399; }    
	.status-color-FAILED { color: #F56C6C; }    
	.status-color-default { color: #909399; }   
	:deep(.el-table__column-filter-trigger.is-active) { color: #409EFF !important; }
</style>